import { Divider } from '@hivebrite/design-system/Divider';

import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

import ColumnSettings from './ColumnSettings';
import GlobalSettings from './GlobalSettings';

const Column = ({
  defaultAttributes,
  item,
  onChange,
  permissions,
}: ComponentSettingsTab<SectionItemAttributes>) => {
  const settingProps = { defaultAttributes, item, onChange, permissions };

  return (
    <AccordionTitle title={__('Column')}>
      <GlobalSettings {...settingProps} />
      <Divider mb={5} mt={2} />
      <ColumnSettings {...settingProps} />
    </AccordionTitle>
  );
};

export default Column;
